import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessAddresses } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { canEditAddresses, canManageAddresses } from "./permissions";
import { addressRoutes } from "./routes";

export const addressesRoute = [
  {
    path: addressRoutes.list,
    lazy: async () => {
      const { AddressListPage } = await import("./pages/AddressListPage");

      return {
        element: (
          <RequireAuth permission={canAccessAddresses}>
            <AddressListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: addressRoutes.new,
    lazy: async () => {
      const { CreateAddressPage } = await import("./pages/CreateAddressPage");

      return {
        element: (
          <RequireAuth permission={canManageAddresses}>
            <CreateAddressPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: addressRoutes.edit,
    lazy: async () => {
      const { EditAddressPage } = await import("./pages/EditAddressPage");

      return {
        element: (
          <RequireAuth permission={canEditAddresses}>
            <EditAddressPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: addressRoutes.bulkUpload,
    lazy: async () => {
      const { AddressBulkUploadPage } = await import("./pages/AddressBulkUploadPage");

      return {
        element: (
          <RequireAuth permission={canManageAddresses}>
            <AddressBulkUploadPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
